import {
  LEADS,
  LEADS_PATH,
  LEADS_SALES_FUNNELS,
} from '@app/constants/navigation';

export const LEADS_PAGE_KEY = LEADS;
export const SALES_FUNNELS_LEADS_KEY = LEADS_SALES_FUNNELS;
export const LEAD_CARD_KEY = 'lead-card';

export const LEADS_PAGE_PATH = LEADS_PATH;
export const SALES_FUNNELS_LEADS_PATH = `${LEADS_PAGE_PATH}/funnels`;
export const LEAD_CARD_PATH = `${LEADS_PAGE_PATH}/:leadId`;
export const SALES_FUNNELS_LEAD_CARD_PATH = `${SALES_FUNNELS_LEADS_PATH}/card`;

export const LEADS_PAGE_TITLE = 'Лиды';
export const SALES_FUNNELS_LEADS_TITLE = 'Лиды по воронкам';
export const LEAD_CARD_TITLE = 'Сообщения';

export const LEADS_REGISTRY_MENU_TITLE = 'Реестр';
export const SALES_FUNNELS_LEADS_MENU_TITLE = 'Воронки';
